import { addresses, menuItems } from "./data";
import type { CartLine } from "./types";

export const formatMoney = (value: number) =>
  new Intl.NumberFormat("vi-VN", { style: "currency", currency: "VND", maximumFractionDigits: 0 }).format(value);

export const getItem = (itemId: string) => menuItems.find((item) => item.id === itemId);

export const getLineUnitPrice = (line: CartLine) => {
  const item = getItem(line.itemId);
  if (!item) return 0;
  const modifierPrice = Object.entries(line.modifiers).reduce((sum, [groupId, optionId]) => {
    const group = item.modifierGroups.find((candidate) => candidate.id === groupId);
    const option = group?.options.find((candidate) => candidate.id === optionId);
    return sum + (option?.price ?? 0);
  }, 0);
  return item.price + modifierPrice;
};

export const getSubtotal = (cart: CartLine[]) =>
  cart.reduce((sum, line) => sum + getLineUnitPrice(line) * line.quantity, 0);

export const getDeliveryFee = (addressId?: string) => {
  const address = addresses.find((candidate) => candidate.id === addressId);
  if (!address) return 0;
  if (address.distance > 5) return -1;
  return address.distance <= 2 ? 18_000 : 28_000;
};

export const getCartAllergens = (cart: CartLine[]) =>
  [...new Set(cart.flatMap((line) => getItem(line.itemId)?.allergens ?? []))];

export const validateRequiredModifiers = (itemId: string, modifiers: Record<string, string>) => {
  const item = getItem(itemId);
  if (!item) return "Không tìm thấy món.";
  const missing = item.modifierGroups.find((group) => group.required && !modifiers[group.id]);
  return missing ? `Chọn ${missing.label.toLowerCase()} trước khi thêm vào giỏ.` : "";
};
